import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { redOrGreen } from '../utils/style-utils';
import { renderMoney } from '../utils/money-utils';
import accounting from 'accounting';

const CryptoTableDataCell = styled.td`
  padding: 2px 5px !important;
  border: 3px solid #eee !important;
  vertical-align: middle;
`;

export default function ListItemTable({ currency, selectedFiatCurrency }) {
  return (
    <table currency={currency}>
      <tbody>
        <tr>
          <CryptoTableDataCell>
            <strong>FLAG</strong>
          </CryptoTableDataCell>
          <CryptoTableDataCell>
            <strong>{currency.name}</strong>
          </CryptoTableDataCell>
          <CryptoTableDataCell />
        </tr>
        <tr>
          <CryptoTableDataCell style={{ textAlign: 'center' }}>
            <span style={redOrGreen(currency.percent_change_1h)}>
              <strong>1h</strong>
              <br /> {currency.percent_change_1h}%
            </span>
          </CryptoTableDataCell>
          <CryptoTableDataCell style={{ textAlign: 'center' }}>
            <span style={redOrGreen(currency.percent_change_24h)}>
              <strong>24h</strong>
              <br /> {currency.percent_change_24h}%
            </span>
          </CryptoTableDataCell>
          <CryptoTableDataCell style={{ textAlign: 'center' }}>
            <span style={redOrGreen(currency.percent_change_7d)}>
              <strong>7d</strong>
              <br /> {currency.percent_change_7d}%
            </span>
          </CryptoTableDataCell>
        </tr>
        <tr>
          <CryptoTableDataCell colSpan={3}>
            <strong>Total Supply:</strong>{' '}
            {accounting.format(currency.total_supply)}
          </CryptoTableDataCell>
        </tr>
        <tr>
          <CryptoTableDataCell colSpan={3}>
            <strong>Market cap:</strong>{' '}
            {renderMoney(currency.market_cap_usd, selectedFiatCurrency)}
          </CryptoTableDataCell>
        </tr>
        <tr>
          <CryptoTableDataCell colSpan={3}>
            <strong>Price:</strong>{' '}
            {renderMoney(currency.price_usd, selectedFiatCurrency)}
          </CryptoTableDataCell>
        </tr>
      </tbody>
    </table>
  );
}

ListItemTable.propTypes = {
  currency: PropTypes.object,
  selectedFiatCurrency: PropTypes.string,
};
